import AxiosService from '../AxiosService';

const RegisterCard = async (
  clientCode: string,
  card_id: string,
  card_token_bearer: string,
) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post(
    `/iopay/customers/${clientCode}/associate-card`,
    {card_id},
    {
      headers: {
        'X-Card-Token-Bearer': card_token_bearer,
      },
    },
  );
  return response.data;
};

const GetCustomer = async (clientCode: string) => {
  try {
    const instance = AxiosService.createProductsAxiosInstance();
    console.log('Fetching customer data...');
    const response = await instance.get(`/iopay/customers/${clientCode}`);
    console.log('Customer data fetched successfully:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching customer data:', error);
  }
};

const GetCards = async (clientCode: string, card_token_bearer: string) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.get(`/iopay/customers/${clientCode}/cards`, {
    headers: {
      'X-Card-Token-Bearer': card_token_bearer,
    },
  });
  return response.data;
};

const CreateCustomer = async (data: object) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post(`/iopay/customers`, data);
  return response.data;
};

const SetDefault = async (
  clientCode: string,
  card_id: string,
  card_token_bearer: string,
) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.post(
    `/iopay/customers/${clientCode}/set-default-card`,
    {card_id},
    {
      headers: {
        'X-Card-Token-Bearer': card_token_bearer,
      },
    },
  );
  return response.data;
};

const RemoveCard = async (
  clientCode: string,
  card_id: string,
  card_token_bearer: string,
) => {
  const instance = AxiosService.createProductsAxiosInstance();
  const response = await instance.delete(
    `/iopay/customers/${clientCode}/cards/${card_id}`,
    {
      headers: {
        'X-Card-Token-Bearer': card_token_bearer,
      },
    },
  );
  return response.data;
};

export default {
  RegisterCard,
  GetCustomer,
  CreateCustomer,
  GetCards,
  SetDefault,
  RemoveCard,
};
